export default __webpack_public_path__ + "static/media/cart.d146d6c3.svg";